import type { AdditionalCoverageSavePayload } from '../../service-step/forms/additional-coverage.form';
import {
  SIGNATURE_REQUIREMENT_ZS50,
  SIGNATURE_REQUIREMENT_NONE,
  SIGNATURE_REQUIREMENT_RES,
  type SignatureRequirement,
  type SignatureProtectionSavePayload,
} from '../../service-step/forms/signature-protection.form';

/** Display model for the Additional Services review card. */
export interface ReviewAdditionalServicesView {
  declaredValue: number | null;
  signatureI18nKey: string;
}

const SIGNATURE_I18N_KEYS: Record<SignatureRequirement, string> = {
  [SIGNATURE_REQUIREMENT_NONE]: 'createShipment.reviewAndPay.signature.none',
  [SIGNATURE_REQUIREMENT_RES]: 'createShipment.reviewAndPay.signature.required',
  [SIGNATURE_REQUIREMENT_ZS50]: 'createShipment.reviewAndPay.signature.adult',
};

/**
 * Maps persisted coverage and signature payloads into Additional Services review fields.
 * Shows a single signature value (the selected requirement), not the Figma stacked mock.
 */
export function mapReviewAdditionalServices(
  coverage: AdditionalCoverageSavePayload | undefined,
  signature: SignatureProtectionSavePayload | undefined,
): ReviewAdditionalServicesView {
  const requirement = signature?.requirement ?? SIGNATURE_REQUIREMENT_NONE;
  return {
    declaredValue: coverage?.declaredValue ?? null,
    signatureI18nKey:
      SIGNATURE_I18N_KEYS[requirement] ?? SIGNATURE_I18N_KEYS[SIGNATURE_REQUIREMENT_NONE],
  };
}
